import React from 'react';

import { FormOutlined } from '@ant-design/icons';

const NotificationCardModuleUpdateIcon = () => {
  return <FormOutlined className="text-xl text-lime-500" />;
};

export default NotificationCardModuleUpdateIcon;
